import type { MenuItem } from "@v1/components/designSystem/menu/Menu";
import type { ReploSimpleProject } from "schemas/generated/project";

import * as React from "react";

import DeprecatedIconButton from "@v1/components/designSystem/button/IconButton";
import { Menu, MenuTrigger } from "@v1/components/designSystem/menu/Menu";
import { useIsWorkspaceOwner } from "@v2/hooks/useIsWorkspaceOwner";
import { MoreHorizontal, MoreVertical } from "lucide-react";
import { filterNulls } from "replo-utils/lib/array";

type ProjectMenuProps = {
  project: ReploSimpleProject;
  isVertical?: boolean;
  onRenameOpen: () => void;
  allowsRenaming: boolean;
};

const ProjectMenu: React.FC<ProjectMenuProps> = ({
  project,
  isVertical = false,
  onRenameOpen,
  allowsRenaming,
}) => {
  const isWorkspaceOwner = useIsWorkspaceOwner(project?.ownerWorkspace?.id);

  const selectableItems: MenuItem[] = isWorkspaceOwner
    ? filterNulls([
        allowsRenaming
          ? {
              type: "leaf",
              id: "renameProject",
              variant: "default",
              size: "sm",
              title: "Rename",
              onSelect: onRenameOpen,
            }
          : null,
      ])
    : filterNulls([
        allowsRenaming
          ? {
              type: "leaf",
              id: "renameProject",
              variant: "default",
              size: "sm",
              title: "Rename",
              onSelect: onRenameOpen,
            }
          : null,
      ]);

  if (selectableItems.length === 0) {
    return null;
  }

  return (
    <Menu
      align="end"
      size="sm"
      items={selectableItems}
      trigger={
        <MenuTrigger tooltipText="More options" asChild>
          <DeprecatedIconButton
            variant="tertiary"
            size="sm"
            icon={
              isVertical ? (
                <MoreVertical size={16} className="text-muted" />
              ) : (
                <MoreHorizontal size={16} className="text-muted" />
              )
            }
            aria-hidden
          >
            <span className="sr-only">More options</span>
          </DeprecatedIconButton>
        </MenuTrigger>
      }
    />
  );
};

export default ProjectMenu;
